<template>
  <div ref="tablePage" style="height: 100%">
    <!-- 面包屑导航 -->
    <div class="topNav">
      <div class="navFormWrapper">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/homePage' }"
            >首页</el-breadcrumb-item
          >
          <el-breadcrumb-item>销售评价</el-breadcrumb-item>
        </el-breadcrumb>
        <el-button
          type="success"
          style="margin-left: 8vh"
          icon="el-icon-plus"
          @click="handleNewAdd"
          size="mini"
          >新增评价</el-button
        >
      </div>
    </div>
    <el-table
      :data="tableList"
      style="width: 100%; margin-top: 2vh"
      border
      size="mini"
      :header-cell-style="{
        background: '#fff',
        height: '50px',
        color: '#909399',
        fontSize: '16px',
        fontFamily: 'Arial, sans-serif',
      }"
    >
      <el-table-column prop="title" label="评价名称" align="center" />
      <el-table-column prop="count" label="点击次数" align="center" />
      <el-table-column prop="status" label="状态" align="center">
        <template slot-scope="scope">
          <el-switch
            v-model="scope.row.status"
            :active-value="1"
            :inactive-value="0"
            @change="changeStatus(scope.row)"
          ></el-switch>
        </template>
      </el-table-column>
      <el-table-column fixed="right" label="操作" align="center">
        <template slot-scope="scope">
          <el-button
            @click.native.prevent="handleClick(scope.row)"
            type="primary"
            size="small"
            icon="el-icon-edit"
          >
            修改
          </el-button>
          <el-button
            @click.native.prevent="singleDel(scope.row, scope.row.id)"
            type="danger"
            size="small"
            icon="el-icon-delete"
          >
            移除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagination
      v-show="total > 0"
      :total="total"
      :page.sync="searchForm.page"
      :limit.sync="searchForm.pageSize"
      @pagination="initList"
    />
    <el-dialog
      :title="title"
      :visible.sync="addOrEditOpen"
      :close-on-click-modal="false"
      width="30%"
      class="global-dialog-position"
      :before-close="getout"
    >
      <el-form ref="form" :model="form" label-width="80px" :rules="rules">
        <el-row>
          <el-col :span="24">
            <el-form-item label="名称" prop="title">
              <el-input
                v-model="form.title"
                autocomplete="off"
                placeholder="请输入"
              />
            </el-form-item>
            <el-form-item label="排序" prop="sort">
              <el-input
                v-model="form.sort"
                autocomplete="off"
                placeholder="请输入"
              />
            </el-form-item>
            <el-form-item label="点击次数" prop="count">
              <el-input
                v-model="form.count"
                autocomplete="off"
                placeholder="请输入"
                disabled
              />
            </el-form-item>
          </el-col>
        </el-row>
        <!-- <el-row>
            <el-col :span="24">
              <el-form-item label="公司状态">
                <el-radio-group v-model="form.status">
                  <el-radio
                    v-for="item in regionTypes"
                    :label="item.label"
                    :key="item.label"
                    >{{ item.text }}</el-radio
                  >
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row> -->
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm">确 定</el-button>
        <el-button @click="getout">取 消</el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="图片"
      :visible.sync="upImg"
      :close-on-click-modal="false"
      width="85%"
      class="dialogHeight global-dialog-position"
      style="margin-top: -7vh"
    >
      <imgUpload ref="imgUpload" />
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm">确 定</el-button>
        <!-- <el-button @click="getout">取 消</el-button> -->
      </div>
      <div slot="body" style="height: 50vh"></div>
    </el-dialog>
  </div>
</template>
  
  <script>
import tableCommon from "../../../mixins/table-common";
import imgUpload from "../../components/uploadImg.vue";
import { getCookie } from "../../utils/util";
import { gettagList, addTag, editTag, deleteTag } from "../../api/personTag";
export default {
  mixins: [tableCommon],
  components: {
    imgUpload,
  },
  data() {
    return {
      // 请求地址api
      api: {
        list: gettagList,
        add: addTag,
        del: deleteTag,
        edit: editTag,
      },
      // 规则验证
      rules: {
        title: [{ required: true, message: "请输入名称", trigger: "blur" }],
      },
      // 传参
      form: {
        status: "1",
      },
      // 弹窗标题
      title: "新增",
      addOrEditOpen: false,
      // 查询参数
      searchForm: {
        page: 1,
        pageSize: 15,
      },
      tableData: [],
      // 上传头文件
      headers: {
        Authorization: "Bearer " + getCookie("logintoken"),
      },
      // 图片上传地址
      uploadImgUrl: process.env.VUE_APP_URL + "/admin/uploadFile",
      imgFirst: false,
      upImg: false,
    };
  },
  methods: {
    // 状态修改
    changeStatus(res) {
      this.form = JSON.parse(JSON.stringify(res));

      editTag(this.form).then((msg) => {
			if (msg.code == 200) {
				return this.$message.success(msg.msg);
			}
			return this.$message.error(msg.msg)
      });
    },
    // 重置
    reset() {
      this.form = {
        status: undefined,
        title: undefined,
      };
    },
    // 新增弹窗
    handleNewAdd() {
      this.title = "新增";
      this.reset();
      this.form.status = 1;
      this.handleAdd();
    },
    // 修改弹窗
    handleClick(row) {
      this.title = "修改";
      this.form = JSON.parse(JSON.stringify(row));
      if (this.$refs.imgUpload) {
        this.$refs.imgUpload.faData.url = "";
      }
      this.handleEdit();
    },
    // 关闭弹窗
    getout() {
      this.addOrEditOpen = false;
      this.$refs.form.clearValidate();
    },
  },
};
</script>
  <style scoped>
/deep/.dialogHeight .el-dialog__body {
  height: 100%;
  overflow: hidden;
}
.chooseImg {
  display: flex;
  align-items: center;
}
/deep/.el-table,
.el-table th,
.el-table td {
  border-radius: 10px;
  -webkit-font-smoothing: antialiased;
  text-rendering: optimizeLegibility;
  font-size: 16px;
  font-family: Times, "Times New Roman";
  /* font-weight: 600; */
}
.topNav {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #fff;
  padding: 20px 20px;
  border-radius: 10px;
}

.navFormWrapper {
  display: flex;
  align-items: center;
}
.avatar-wrapper {
  position: relative;
}

.avatar-wrapper img.avatar {
  max-width: 100%;
  max-height: 100%;
}

.avatar-wrapper .el-icon-close {
  position: absolute;
  top: 5px;
  right: 5px;
  font-size: 18px;
  color: #fff;
  background-color: rgba(0, 0, 0, 0.5);
  padding: 5px;
  border-radius: 50%;
  cursor: pointer;
}
.navFormWrapper {
  display: flex;
  align-items: center;
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 150px;
  height: 150px;
  line-height: 150px;
  text-align: center;
  border: 1px solid #dcdfe6;
}
.avatar {
  width: 150px;
  height: 150px;
  display: block;
}
.el-icon-close {
  position: absolute;
  top: 0;
  right: 7vh;
  cursor: pointer;
}
.closes {
  right: 54vh;
}
.el-icon-close:hover {
  color: #409eff;
}
.el-icon-close2 {
  position: absolute;
  top: 0;
  right: 55vh;
  cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/views/identity/personTag.vue